import React from 'react'
import { useContext } from '../Context'
import { ContactUsButton } from '../../../../components/ContactUsButton'
import AddToBoard from '../../../../components/AddToBoard'
import { formatMoney } from '@ztechapps/common.utils'
import { ButtonGroup, Col, Row, Stack } from 'react-bootstrap'
import { AddToCartButton } from '../../../../components/Product/AddToCartButton'
import { HorizontalStack, LoadingPlaceholder, ShowIf } from '@ztechapps/webui.util'
import { DiscountLabel, PricePerUom } from '@ztechapps/product.webui'

export const ProductInfo = () => {
  const { document, loading } = useContext()

  return (
    <article className="product-info-aside">
      <Stack gap={2}>
        <LoadingPlaceholder loading={loading} size="medium">
          <h2 className="title mt-3">
            [{document?.code}] - {document?.name}
          </h2>
        </LoadingPlaceholder>

        <LoadingPlaceholder loading={loading} size="small">
          <HorizontalStack gap={2} className={'align-items-center'}>
            <PricePerUom price={document?.price} uom={document?.orderUom?.name} className="h5 m-0 text-muted" />
            <ShowIf condition={document?.discountPercentage > 0}>
              <div>
                <s>{formatMoney(document?.originalPrice)}</s>
              </div>
            </ShowIf>
            <DiscountLabel discountPercentage={document?.discountPercentage} />
          </HorizontalStack>
        </LoadingPlaceholder>

        <LoadingPlaceholder loading={loading} size="small">
          <dl className="row">
            <dt className="col-sm-3">Product code</dt>
            <dd className="col-sm-9">{document?.code}</dd>
          </dl>
        </LoadingPlaceholder>
      </Stack>

      <LoadingPlaceholder loading={loading} size="small">
        <Row>
          <Col lg xs={12} className="my-1">
            <ButtonGroup>
              <AddToCartButton bsStyle="primary" product={{ code: document?.code, _id: document?._id }} />
              <ContactUsButton />
              <AddToBoard product={document} />
            </ButtonGroup>
          </Col>
        </Row>
      </LoadingPlaceholder>
    </article>
  )
}
